/**
 * PostHog initialization for web app onboarding
 *
 * Configures PostHog once per session and exposes helpers to identify patients by `signUpId`.
 */

import posthog from 'posthog-js';
import 'posthog-js/dist/surveys';
import { isDemoOnboardingInvitation } from '../../services/onboardingProgress';

let onboardingAnalyticsInitialized = false;

export function initOnboardingAnalytics(): void {
  if (onboardingAnalyticsInitialized) {
    return;
  }

  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    ui_host: 'https://eu.posthog.com',
    persistence: 'memory',
    autocapture: false,
    capture_pageview: 'history_change',
  });

  onboardingAnalyticsInitialized = true;
}

export function buildOnboardingPersonProperties(signUpId: string): Record<string, unknown> {
  return {
    signedUpPatientId: signUpId,
    ...(isDemoOnboardingInvitation(signUpId) ? { $internal_or_test_user: true } : {}),
  };
}

export function identifyBySignUpId(signUpId: string): void {
  posthog.identify(signUpId, buildOnboardingPersonProperties(signUpId));
  posthog.reloadFeatureFlags();
}
